import fetch from "auth/FetchInterceptor";

const CandidateService = {};

CandidateService.GetCandidateSSSR = async function (data) {
  return fetch({
    url: "/Candidate/GetAllSSR",
    method: "post",
    data: data,
  });
};
CandidateService.GetCandidateById = async function (params) {
  return fetch({
    url: "/Candidate/GetById",
    method: "get",
    params,
  });
};
CandidateService.SetActive = async function (params) {
  return fetch({
    url: "/Candidate/SetIsActive",
    method: "get",
    params,
  });
};
CandidateService.GetLanguages = async function () {
  return fetch({
    url: "/Candidate/GetLanguages",
    method: "get",
  });
};
CandidateService.GetLanguageLevels = async function () {
  return fetch({
    url: "/Candidate/GetLanguageLevels",
    method: "get",
  });
};
CandidateService.GetBloodTypes = async function () {
  return fetch({
    url: "/Candidate/GetBloodTypes",
    method: "get",
  });
};
CandidateService.GetStatus = async function () {
  return fetch({
    url: "/Candidate/GetStatus",
    method: "get",
  });
};
CandidateService.GetGender = async function () {
  return fetch({
    url: "/Candidate/GetGender",
    method: "get",
  });
};
CandidateService.GetMaritalStatus = async function () {
  return fetch({
    url: "/Candidate/GetMaritalStatus",
    method: "get",
  });
};
CandidateService.GetReligions = async function () {
  return fetch({
    url: "/Candidate/GetReligions",
    method: "get",
  });
};
CandidateService.GetNationalities = async function () {
  return fetch({
    url: "/Candidate/GetNationalities",
    method: "get",
  });
};
CandidateService.GetDegreeTypes = async function () {
  return fetch({
    url: "/Candidate/GetDegreeTypes",
    method: "get",
  });
};
CandidateService.Update = async function (data) {
  return fetch({
    url: "/Candidate/Update",
    method: "post",
    data,
  });
};
CandidateService.CreateAgencyCandidate = async function (data) {
  return fetch({
    url: "/Candidate/CreateAgencyCandidate",
    method: "post",
    data,
  });
};
CandidateService.GetSimpleCanidate = async function (params) {
  return fetch({
    url: "/Candidate/GetSimpleCanidate",
    method: "get",
    params,
  });
};
CandidateService.CandidateHistory = async function (params) {
  return fetch({
    url: "/Candidate/CandidateHistory",
    method: "get",
    params,
  });
};
CandidateService.DownloadSampleExcelFile = async function () {
  return fetch({
    url: "/Candidate/DownloadExcelFile",
    method: "get",
  });
};
CandidateService.BulkUploadCandidate = async function (data) {
  return fetch({
    url: "/Candidate/BulkInsertCandidate",
    method: "post",
    data,
  });
};
export default CandidateService;
